// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"80567cf4","153":"e138c654","552":"055d91e4"}[chunkId] + ".chunk.css";
};